import Head from "next/head";
import { GetStaticProps } from "next/types";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "../components/Header";
import TestimonialCard from "../components/TestimonialCard";
import Title from "../components/Title";
import { testimonials } from "../shared/utils/testimonials";
import IframeResizer from "iframe-resizer-react";
import Cta from "../components/Cta";
import styles from "../styles/pages/resultados.module.scss";

export default function Resultados() {
  useEffect(() => {
    AOS.init({
      disable: "mobile",
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <>
      <Head>
        <title>Resultados | Kenzie Academy Brasil</title>
        <meta
          name="description"
          content="Confira as conquistas dos alunos da Kenzie!"
        />
        <meta
          name="twitter:title"
          content="Resultados | Kenzie Academy Brasil"
        />
        <meta
          name="twitter:description"
          content="Confira as conquistas dos alunos da Kenzie!"
        />
        <meta
          property="og:title"
          content="Resultados | Kenzie Academy Brasil"
        />
        <link rel="canonical" href="https://kenzie.com.br/resultados" />
      </Head>

      <Header />

      <main>
        <section className={styles.wrapper}>
          <div className={styles.background}>
            <div className={styles.container}>
              <div className={styles.contentContainer} data-aos="fade-right">
                <h1 className={styles.title}>
                  Veja como a Kenzie transforma a vida dos alunos
                </h1>
                <p>
                  Confira o que os nossos programadores têm a dizer sobre a
                  Kenzie.
                </p>
                <Cta
                  url="https://inscricao.kenzie.com.br"
                  maxWidthDesktop="28rem"
                  color="white"
                  passParams
                  text="Entrar na Lista de Espera"
                  centralized={false}
                  background
                />
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className={styles.iframeContainer}>
            <IframeResizer
              src="https://embed-v2.testimonial.to/w/kenzie-academy-brasil?theme=light&card=base&loadMore=on&initialCount=20"
              style={{ width: "1px", minWidth: "100%" }}
            />
          </div>
        </section>
      </main>
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24,
  };
};
